import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import * as authApi from '@/api/auth';

export function useAuth() {
  const navigate = useNavigate();
  const {
    token,
    user,
    isAuthenticated,
    isLoading,
    setAuth,
    clearAuth,
  } = useAuthStore();

  const handleOidcCallback = useCallback(async (jwt: string, returnTo?: string) => {
    useAuthStore.setState({ token: jwt, isAuthenticated: true });
    const response = await authApi.sync();
    setAuth(jwt, response.user);

    if (returnTo) {
      navigate(returnTo);
    } else {
      navigate('/landing');
    }
  }, [setAuth, navigate]);

  const logout = useCallback(() => {
    clearAuth();
    navigate('/login');
  }, [clearAuth, navigate]);

  return {
    token,
    user,
    isAuthenticated,
    isLoading,
    handleOidcCallback,
    logout,
  };
}
